import { toast } from "react-toastify";
import ApiConfig from "../config/ApiConfig";
import { errorMessage } from "../lib/helper";
import {
  setPropertyScheduledForVisitData,
  setPropertyScheduledForVisitDataLoading,
  setPropertyScheduledForVisitDataError,
  setPropertyBookedForVisitList,
  setPropertyBookedForVisitListLoading,
  setPropertyBookedForVisitListError,
  setTimeSlotDataList,
  setTimeSlotDataListLoading,
  setTimeSlotDataListError,
  setPropertyScheduledForAuditedDataLoading,
  setPropertyScheduledForAuditedData,
  setPropertyScheduledForAuditedDataError,
  setPropertyToBeAuditedData,
  setPropertyToBeAuditedDataLoading,
  setPropertyToBeAuditedDataError,
} from "../redux/agentDashboard";

import { STATUS_200, STATUS_300 } from "../data/constants";
import agentAxios from "../lib/AxiosInterceptor";

export const GetAllPropertyToBeAuditedData = (
  currentPage,
  currentPageLimit
) => {
  return async (dispatch) => {
    try {
      dispatch(setPropertyToBeAuditedDataLoading(true));
      const resp = await agentAxios.get(
        `${ApiConfig.agentPopertyToBeAudited}${
          currentPage ? `?page=${currentPage}` : ""
        }${
          currentPageLimit
            ? `${currentPage ? "&" : "?"}limit=${currentPageLimit}`
            : ""
        }`
      );
      if (resp?.status >= STATUS_200 && resp?.status < STATUS_300) {
        dispatch(setPropertyToBeAuditedData(resp?.data?.data));
        dispatch(setPropertyToBeAuditedDataLoading(false));
      } else {
        throw resp;
      }
    } catch (e) {
      dispatch(
        setPropertyToBeAuditedDataError({
          isError: true,
          message: errorMessage(e),
        })
      );
      toast.error(errorMessage(e), {
        autoClose: 2000,
      });
      dispatch(setPropertyToBeAuditedDataLoading(false));
    }
  };
};
export const GetAllPropertyBookedForVisitDataList = (currentPage, currentPageLimit) => {
  return async (dispatch) => {
    try {
      dispatch(setPropertyBookedForVisitListLoading(true));
      const resp = await agentAxios.get(
        `${ApiConfig.agentPropertyBookedForVisit}${
          currentPage ? `?page=${currentPage}` : ""
        }${
          currentPageLimit
            ? `${currentPage ? "&" : "?"}limit=${currentPageLimit}`
            : ""
        }`);
      if (resp?.status >= STATUS_200 && resp?.status < STATUS_300) {
        dispatch(setPropertyBookedForVisitList(resp?.data?.data));
        dispatch(setPropertyBookedForVisitListLoading(false));
      } else {
        throw resp;
      }
    } catch (e) {
      dispatch(
        setPropertyBookedForVisitListError({
          isError: true,
          message: errorMessage(e),
        })
      );
      toast.error(errorMessage(e), {
        autoClose: 2000,
      });
      dispatch(setPropertyBookedForVisitListLoading(false));
    }
  };
};
export const GetAllPropertyScheduledForVisitList = (currentPage, currentPageLimit) => {
  return async (dispatch) => {
    try {
      dispatch(setPropertyScheduledForVisitDataLoading(true));
      const resp = await agentAxios.get(
        `${ApiConfig.agentPropertyScheduledForVisit}${
          currentPage ? `?page=${currentPage}` : ""
        }${
          currentPageLimit
            ? `${currentPage ? "&" : "?"}limit=${currentPageLimit}`
            : ""
        }`);
      if (resp?.status >= STATUS_200 && resp?.status < STATUS_300) {
        dispatch(setPropertyScheduledForVisitData(resp?.data?.data));
        dispatch(setPropertyScheduledForVisitDataLoading(false));
      } else {
        throw resp;
      }
    } catch (e) {
      dispatch(
        setPropertyScheduledForVisitDataError({
          isError: true,
          message: errorMessage(e),
        })
      );
      toast.error(errorMessage(e), {
        autoClose: 2000,
      });
      dispatch(setPropertyScheduledForVisitDataLoading(false));
    }
  };
};

export const GetAllPropertyScheduledForAuditData = (currentPage, currentPageLimit) => {
  return async (dispatch) => {
    try {
      dispatch(setPropertyScheduledForAuditedDataLoading(true));
      const resp = await agentAxios.get(
        `${ApiConfig.agentPopertyScheduledForAudited}${currentPage ? `?page=${currentPage}` : ""
        }${currentPageLimit
          ? `${currentPage ? "&" : "?"}limit=${currentPageLimit}`
          : ""
        }`);
      if (resp?.status >= STATUS_200 && resp?.status < STATUS_300) {
        dispatch(setPropertyScheduledForAuditedData(resp?.data?.data));
        dispatch(setPropertyScheduledForAuditedDataLoading(false));
        return true;
      } else {
        throw resp;
      }
    } catch (e) {
      dispatch(
        setPropertyScheduledForAuditedDataError({
          isError: true,
          message: errorMessage(e),
        })
      );
      toast.error(errorMessage(e), {
        autoClose: 2000,
      });
      dispatch(setPropertyScheduledForAuditedDataLoading(false));
    }
  };
};
